import { render, staticRenderFns } from "./ModifyProductOnProductSetButton.vue?vue&type=template&id=b5598a78&scoped=true"
import script from "./ModifyProductOnProductSetButton.vue?vue&type=script&lang=js"
export * from "./ModifyProductOnProductSetButton.vue?vue&type=script&lang=js"
import style0 from "./ModifyProductOnProductSetButton.vue?vue&type=style&index=0&id=b5598a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5598a78",
  null
  
)

export default component.exports